import { Component, Input, EventEmitter, Output } from "@angular/core";

@Component({
    selector: 'pbc-tilesbar',
    moduleId: module.id,
    templateUrl: 'tilesbar.component.html',
    styleUrls: ['./tilesbar.component.less']
})
export class TilesBarComponent {
    @Input() tiles: string = null;
    @Input() basepath: string = null;
    @Output() onTileSelected: EventEmitter<string> = new EventEmitter<string>();

    currentTile: string = "";

    getTiles(): string[] {
        return this.tiles.split('');
    }

    getTileImage(tile: string): string {
        var tiles = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var special_tiles = "0123456789";
        var objects = "abcdefghijklmnopqrstuvwxyz";
        if (tile == " ") return "assets/images/blank.png";
        if (tile == "`") return "assets/images/respawn.png";
        if (tile == "~") return "assets/images/spawn.png";
        if (tiles.indexOf(tile)>=0) {
            return `assets/images/${this.basepath}/Tile_${tile}.png`;
        }
        if (special_tiles.indexOf(tile)>=0) {
            return `assets/images/${this.basepath}/SpecialTile_${tile}.png`;
        }
        if (objects.indexOf(tile)>=0) {
            return `assets/images/${this.basepath}/Obj_${tile}.png`;
        }
    }

    setCurrentTile(tile: string) {
        console.log(tile);
        this.currentTile = tile;
        this.onTileSelected.emit(tile);
    }

}


// WEBPACK FOOTER //
// ./src/app/layout/tilesbar/tilesbar.component.ts